/**
 * Refyne · Newsletter popup
 *
 * 1. Shows the popup (desktop: when the cursor leaves through the top of the
 *    page; phones: after 15 seconds), unless it was dismissed or already used.
 * 2. The signup is a normal Shopify form post. Shopify's spam protection needs
 *    that: it may show a "prove you are human" step, then sends the visitor
 *    back to the page they were on.
 * 3. Back on that page, the popup opens on its "you're in" state, shows the 10%
 *    code and applies it to the cart, so the discount is already there at checkout.
 *
 * Markup and the code itself: snippets/defyne-newsletter-popup.liquid
 */
document.addEventListener('DOMContentLoaded', function () {
  var popup = document.getElementById('defyne-newsletter-popup');
  if (!popup) return;

  var DISMISSED = 'defyne_popup_dismissed'; // closed without joining
  var JOINED    = 'refyne_popup_joined';    // signed up on this device
  var PENDING   = 'refyne_popup_pending';   // time the signup was sent from this popup
  var PENDING_MS = 30 * 60 * 1000;          // how long we wait for Shopify to send them back

  var code        = popup.getAttribute('data-code') || '';
  var form        = document.getElementById('defyne-popup-form');
  var ask         = document.getElementById('defyne-popup-ask');
  var done        = document.getElementById('defyne-popup-done');
  var overlay     = document.getElementById('defyne-popup-overlay');
  var closeBtn    = document.getElementById('defyne-popup-close');
  var dismissBtn  = document.getElementById('defyne-popup-dismiss');
  var submitBtn   = document.getElementById('defyne-popup-submit');
  var errorEl     = document.getElementById('defyne-popup-error');
  var noteEl      = document.getElementById('defyne-popup-note');
  var copyBtn     = document.getElementById('defyne-popup-copy');
  var continueBtn = document.getElementById('defyne-popup-continue');
  var shown = false;

  function get(store, key) { try { return store.getItem(key); } catch (e) { return null; } }
  function set(store, key, value) { try { store.setItem(key, value); } catch (e) {} }
  function remove(store, key) { try { store.removeItem(key); } catch (e) {} }

  function showPopup() {
    if (shown) return;
    shown = true;
    popup.hidden = false;
  }

  function closePopup() {
    popup.hidden = true;
    set(localStorage, DISMISSED, '1');
  }

  /* ---- The discount: put the code on the cart so checkout already has it ---- */
  function applyCode() {
    if (!code) return Promise.resolve(false);
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        var codes = (cart && cart.discount_codes) || [];
        return codes.some(function (c) { return String(c.code).toUpperCase() === code.toUpperCase(); });
      })
      .catch(function () { return false; });
  }

  function showJoined() {
    remove(sessionStorage, PENDING);
    set(localStorage, JOINED, '1');
    set(localStorage, DISMISSED, '1');
    if (ask) ask.hidden = true;
    if (done) done.hidden = false;
    popup.setAttribute('aria-labelledby', 'defyne-popup-done-title');
    shown = true;
    popup.hidden = false;
    var title = document.getElementById('defyne-popup-done-title');
    if (title) title.focus();

    applyCode().then(function (applied) {
      if (!noteEl) return;
      noteEl.textContent = applied
        ? 'It is saved to your cart. Your 10% comes off at checkout.'
        : 'Enter this code at checkout to get your 10% off.';
    });
  }

  /* Was a signup sent from this popup a short while ago? */
  function isPending() {
    var sent = parseInt(get(sessionStorage, PENDING), 10);
    return !!sent && Date.now() - sent < PENDING_MS;
  }

  if (form) {
    form.addEventListener('submit', function () {
      set(sessionStorage, PENDING, String(Date.now()));
      // Let the form post normally; only show that something is happening.
      setTimeout(function () {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'ONE MOMENT…'; }
      }, 0);
    });
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      function copied() {
        copyBtn.textContent = 'Copied';
        setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(copied).catch(function () {});
      }
    });
  }

  if (overlay) overlay.addEventListener('click', closePopup);
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (dismissBtn) dismissBtn.addEventListener('click', closePopup);
  if (continueBtn) continueBtn.addEventListener('click', closePopup);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) closePopup();
  });

  /* ---- Back from Shopify after a signup from this popup ---- */
  var onChallenge = location.pathname.indexOf('/challenge') === 0;

  if (isPending() && !onChallenge) {
    if (/[?&]customer_posted=true/.test(location.search)) {
      showJoined();
      if (window.history && history.replaceState) {
        history.replaceState(null, '', location.pathname + location.hash.replace('#defyne-popup-form', ''));
      }
      return;
    }
    // Shopify sent them back with a problem (for example an address it rejects).
    if (errorEl) {
      remove(sessionStorage, PENDING);
      showPopup();
      return;
    }
  }

  if (onChallenge) return;
  if (get(localStorage, DISMISSED) || get(localStorage, JOINED)) return;

  var isDesktop = window.matchMedia('(min-width: 750px)').matches;

  if (isDesktop) {
    // Exit-intent: cursor moves toward the top of the viewport
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) showPopup();
    });
  } else {
    // 15s delay on mobile
    setTimeout(showPopup, 15000);
  }
});
